import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { AppSumoUpgradePayload } from 'Interfaces/Billing';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: AppSumoUpgradePayload) =>
    $actions.billing.upgradeAppSumo(dispatch, payload),
  );
};
